// MarketDetails Skeleton - Pure MUI (No anonymous functions)
import { Box, Card, CardContent, Skeleton } from '@mui/material';

import GraphSkeleton from './GraphSkeleton';

// Pre-computed arrays to avoid Array.from in JSX
const OUTCOME_ITEMS = [1, 2, 3];

// Extracted components to avoid anonymous functions in JSX
const OutcomeSkeletonItem = () => (
  <Card variant="outlined">
    <CardContent
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1.5, sm: 0 },
        py: { xs: 1.5, sm: 2 },
        '&:last-child': { pb: { xs: 1.5, sm: 2 } },
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Skeleton variant="text" width="100%" height={24} sx={{ maxWidth: 120 }} />
        <Skeleton variant="text" width="100%" height={20} sx={{ maxWidth: 80 }} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
        <Skeleton variant="rounded" width={80} height={36} sx={{ flex: 1, minWidth: 0 }} />
        <Skeleton variant="rounded" width={80} height={36} sx={{ flex: 1, minWidth: 0 }} />
      </Box>
    </CardContent>
  </Card>
);

export const MarketDetailsSkeleton = () => {
  return (
    <Box
      sx={{
        py: { xs: 0.75, sm: 2 },
        px: 0,
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        pb: { xs: 20, md: 2 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: 1, sm: 2, md: 3 },
          alignItems: 'start',
          width: '100%',
        }}
      >
        {/* Left Column */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.5, sm: 2.5 },
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box>
            <Skeleton variant="text" width="80%" height={48} sx={{ mb: 1 }} />
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>

          <GraphSkeleton />

          {/* Outcomes */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {OUTCOME_ITEMS.map((item) => (
              <OutcomeSkeletonItem key={item} />
            ))}
          </Box>
        </Box>

        {/* Right Column - Hidden on mobile (matches TradingSidebar) */}
        <Box
          sx={{ display: { xs: 'none', lg: 'block' }, width: { lg: 380, xl: 420 }, flexShrink: 0 }}
        >
          <Card>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Skeleton variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="40%" height={20} />
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
                <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
              </Box>
              <Skeleton variant="rounded" height={48} />
              <Skeleton variant="rounded" height={48} />
              <Skeleton variant="rounded" height={120} />
              <Skeleton variant="rounded" height={48} />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default MarketDetailsSkeleton;
